import dataApi from '../'

export default {

  generateReport (body) {
    return dataApi.request({
      method: 'post',
      url: 'ui/report/generate-report',
      body: body
    })
  },

  /**
  * Get transactions and clearboxes
  */
  getCampaignsWithBarcodes (body) {
    return dataApi.request({
      method: 'post',
      url: 'ui/report/campaigns-with-barcodes',
      body: body
    })
  },

  getInternalTransactionsByDate (body) {
    return dataApi.request({
      method: 'post',
      url: 'ui/report/internal-transactions-by-date',
      body: body
    })
  },

  getSalesByDate (body) {
    return dataApi.request({
      method: 'post',
      url: 'ui/report/sales-by-date',
      body: body
    })
  },

  getTransactionsWithReference (body) {
    return dataApi.request({
      method: 'post',
      url: 'ui/report/transactions-with-reference',
      body: body
    })
  },

  getReptileTransactionsWithReference (body) {
    return dataApi.request({
      method: 'post',
      url: 'ui/report/reptile-transactions-with-reference',
      body: body
    })
  },

  getManualTransactionsByDate (body) {
    return dataApi.request({
      method: 'post',
      url: 'ui/report/manual-transactions-by-date',
      body: body
    })
  },

  getEndOfDayClientsByDate (body) {
    return dataApi.request({
      method: 'post',
      url: 'ui/report/endofdayclients-by-date',
      body: body
    })
  },

  getEventsByDate (body) {
    return dataApi.request({
      method: 'post',
      url: 'ui/report/events-by-date',
      body: body
    })
  },

  getReportTypes (unitUuids) {
    return dataApi.request({
      method: 'post',
      url: 'ui/report/reports-list',
      body: {unitUuids: unitUuids}
    })
  },

  getAvailableUnitsForOrganization (orgUuid) {
    return dataApi.request({
      method: 'get',
      url: `ui/v2/reports/organization/${orgUuid}/available-units`
    })
  },

  /**
   * Reptile
   */

  getReptileTransactionsByDate (body) {
    return dataApi.request({
      method: 'post',
      url: 'ui/report/reptile-transactions-by-date',
      body: body
    })
  },

  getReptileCampaignsAndTransactionsByDate (body) {
    return dataApi.request({
      method: 'post',
      url: 'ui/report/reptile-campaigns-and-transactions-by-date',
      body: body
    })
  },

  getReptileCampaignsAndTransactionsMoneyInOutCounterByDate (body) {
    return dataApi.request({
      method: 'post',
      url: 'ui/report/reptile-campaigns-and-transactions-money-in-out-by-date',
      body: body
    })
  },

  getReptileReportForDenominationPerUser (body) {
    return dataApi.request({
      method: 'post',
      url: 'ui/report/reptile-denomination-per-user',
      body: body
    })
  },

  getReptileReportForDenominationWithPin (body) {
    return dataApi.request({
      method: 'post',
      url: 'ui/report/reptile-denomination-with-pin',
      body: body
    })
  },

  getReptileReportForClosedCampaignsByUnitAndDate (body) {
    return dataApi.request({
      method: 'post',
      url: 'ui/report/reptile-campaigns-by-date',
      body: body
    })
  },

  getReptileClearboxDenomination (body) {
    return dataApi.request({
      method: 'post',
      url: 'ui/report/reptile-clearbox-denomination',
      body: body
    })
  },

  getReptileClearboxDenominationV2 (body) {
    return dataApi.request({
      method: 'post',
      url: 'ui/report/reptile-clearbox-denomination-v2',
      body: body
    })
  },

  getReptileEndOfDayInfoByDate (body) {
    return dataApi.request({
      method: 'post',
      url: 'ui/report/reptile-endofdayinfo-by-date',
      body: body
    })
  },

  getReptileLincstationEndOfDayInfoByDate (body) {
    return dataApi.request({
      method: 'post',
      url: 'ui/report/reptile-lincstationendofdayinfo-by-date',
      body: body
    })
  },

  getReptileAdvancedManualDeposit (body) {
    return dataApi.request({
      method: 'post',
      url: 'ui/report/reptile-amd',
      body: body
    })
  },

  getReptileSalesByDate (body) {
    return dataApi.request({
      method: 'post',
      url: 'ui/report/reptile-sales-report',
      body: body
    })
  },

  getReptileRecyclerReport (body) {
    return dataApi.request({
      method: 'post',
      url: 'ui/report/reptile-recycler-report',
      body: body
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/endpoints/report.js